import { useEffect } from 'react';

export const useKeyDown = (callbackFn, keys) => {
  const onKeyDown = (event) => {
    const keyPressed = keys.some((key) => event.key === key);
    if (keyPressed) {
      event.preventDefault();
      callbackFn();
    }
  };
  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
};
export default useKeyDown;